module.exports = __webpack_public_path__ + "img/icon email line.5079153c.svg";